export default function truncate(str, n, useWordBoundary) {
    if (str.length <= n) {
        return str;
    }
    const subString = str.substr(0, n - 1); // the original check
    const boundary = subString.lastIndexOf(' ');
    return (
        (useWordBoundary && boundary > 0
            ? subString.slice(0, boundary)
            : subString) + '...'
    );
}
